class ContractTypeAllController {
    /*@ngInject*/
    constructor(Auth, User, $state, $translate, $stateParams, $location, Modal, ContractTypeService) {
        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.Modal = Modal;
        this.ContractTypeService = ContractTypeService;

        this.model = {
            contractTypeObj: {
                totalRecords: 0,
                contractTypeList: [],
                loading: false
            },
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            errorMessage: '',
            branchId: User.getUser().branchId,
            searchText: '',
        }
    }

    $onInit() {
        this.loadData();
    }

    searchObj() {
        const obj = {
            queryJSON: {
                rules: [{
                    group: {
                        rules: [{
                            field: 'type',
                            condition: 'like',
                            data: '%' + this.model.searchText + '%'
                        }],
                        operator: 'OR'
                    }
                }],
                operator: 'AND'
            }
        }
        return obj.queryJSON.rules.length ? obj : null;
    }

    loadAllContractType() {
        this.model.contractTypeObj.loading = true;

        this.ContractTypeService.all(this.searchObj(), (this.model.pagination.page - 1) * this.model.pagination.pageLimit, this.model.pagination.pageLimit)
            .then((data) => {
                this.model.contractTypeObj.contractTypeList = data.results;
                this.model.contractTypeObj.totalRecords = data.total;
            })
            .catch((err) => {
                this.Modal.errorModal(err.data.message);
            })
            .finally(() => {
                this.model.contractTypeObj.loading = false;
            })
    }

    pageChange() {
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.model.pagination.page)
        this.$stateParams.page = this.model.pagination.page;
        this.$location.path(newUrl);
        this.loadAllContractType();
    }

    loadData() {
        this.model.pagination.page = 1;
        this.loadAllContractType();
    }

    search() {
        this.pageChange();
    }

    edit(contractType) {
        this.$state.go('contract_type.edit', ({
            id: contractType.id
        }))
    }
}
export default ContractTypeAllController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract_type/all/contract_type.all.controller.js